/**
 * @file label-texts.ts
 * @description Тексты печати этикеток (phase19.22, ui-design §1–§3, §5) —
 *   одним реестром: одна фраза, несколько мест показа (диалог, блок приёмки,
 *   остатки, настройки). Тексты — языком кладовщика, без кодов ошибок.
 */

import { pluralRu } from "../../../lib/plural";

export const LABEL_TEXT = {
  dialogTitle: "Печать этикеток",
  submit: "Сформировать PDF",
  submitting: "Готовим PDF…",
  printerHint: "При печати выберите Kyocera и масштаб 100 % («Фактический размер»).",
  nothingChecked: "Отметьте позиции и укажите количество",
  renderFailed:
    "Сервис печати сейчас недоступен. Приёмка проведена и не пострадала — повторите через минуту.",
  retry: "Повторить",
  open: "Открыть для печати",
  download: "Скачать",
  done: "Готово",
  printMore: "Напечатать ещё",
  code128Warning: "«Штрих» — без партии и срока: при сборке партия не сверится.",
  miniCodeNote: "Мини — только DataMatrix.",
  noLotWarning:
    "На этикетке не будет партии и срока — при сборке заказа партия не сверится. " +
    "Для товара на складе выберите партию.",
  noLots: "Партий с остатком нет — можно напечатать только без партии.",
  templateAuto: "По фасовке",
  draftDisabled: "Этикетки печатаются после проведения приёмки",
  staleFood: "Для пищевого товара переклейка обязательна.",
  historyTitle: "История печати",
  historyScroll: "К истории печати",
  reprint: "Перепечатать",
  fileNone: "не сформирован",
  cutLinesTitle: "Линии реза",
  cutLinesHint: "Пунктир по границе наклеек (для печати на обычной бумаге; на самоклейке выключите)",
  cutLinesSummary: "с линиями реза",
  hideFile: "Скрыть файл",
  hideFileTitle: "Скрыть файл печати?",
  hideFileText:
    "Файл будет скрыт из истории, запись о печати останется. Перепечатать можно в любой момент.",
  hideFileDone: "Файл скрыт",
} as const;

/** Якорь секции «История печати» в подвале приёмки (`≥lg`). */
export const LABEL_PRINT_LOG_ANCHOR = "label-print-log";

/** «файл скрыт · 26.09.2026 14:05» — у записи журнала со скрытым файлом. */
export function fileHiddenText(when: string): string {
  return `файл скрыт · ${when}`;
}

/** «Готово: 2 листа, 36 этикеток». */
export function resultTitle(sheets: number, labels: number): string {
  return (
    `Готово: ${sheets} ${pluralRu(sheets, ["лист", "листа", "листов"])}, ` +
    `${labels} ${pluralRu(labels, ["этикетка", "этикетки", "этикеток"])}`
  );
}

/** «Это 21 лист — проверьте запас самоклейки». */
export function manySheetsWarning(sheets: number): string {
  return `Это ${sheets} ${pluralRu(sheets, ["лист", "листа", "листов"])} — проверьте запас самоклейки.`;
}

/** «2 позиции изменились после печати — старые этикетки неверны…». */
export function staleNotice(count: number): string {
  const verb = count === 1 ? "изменилась" : "изменились";
  return (
    `${count} ${pluralRu(count, ["позиция", "позиции", "позиций"])} ${verb} после печати — ` +
    "старые этикетки неверны. Перепечатайте и переклейте их."
  );
}

/** «Печать (212)» — кнопка полосы выбора в остатках. */
export function printCountLabel(labels: number): string {
  return `Печать (${labels})`;
}
